import React from 'react';
import { TypeAnimation } from 'react-type-animation';

const Hero = () => {
  return (
    <section className="hero-section">
        <div className='glass-box'>
          <div className='hero-text'>
          <TypeAnimation
              sequence={[
                500,
                '< Hello world! />',
                500,
                '< Welcome! />'
              ]}
              speed={50}
              className='text-medium'
              repeat={Infinity}
            />
            <h1>My name is <span className='highlight'>Emanuela</span></h1>
            <p>I'm a software engineer, crafting digital solutions.</p>
          </div>
          <div className='btn-group'>
              <a aria-label="About me section" href='#aboutme' className='btn'>
                <span>&lt;AboutMe/&gt;</span>
              </a>
              <a aria-label="Projects section" href='#projects' className='btn'>
                <span>&lt;Projects/&gt;</span>
              </a>
              <a aria-label="Contact me section" href='#contactme' className='btn'>
                <span>&lt;ContactMe/&gt;</span>
              </a>
          </div>
        </div>
    </section>
  );
};

export default Hero;